
import Spinner from "./Spinner";
import Typography from "@mui/material/Typography";

import { useQuery } from '@tanstack/react-query'
import {categoryList, typeList, statusList} from '../models/categories';
import { listLabel } from '../utils/lists';
import { dateLocaleFormat } from "../utils/datetime";
import Box from "@mui/material/Box";

import { allOpenAnimalChanges, sortDescStart } from "../utils/changes";

export default function AnimalChangeSummary({animal, changes = [], containerProps = {},typographyProps = {},...props}) {

    const {isLoading, data} = useQuery({
        queryKey: ['categories'],
        queryFn: async() => {
            return {
                categories: await categoryList(),
                types: await typeList(),
                statuses: await statusList(),
            };
        },
        networkMode: "offlineFirst",
    });

    const openChangesForAnimal = allOpenAnimalChanges(animal,changes);
    openChangesForAnimal.sort(sortDescStart);

    return (
    <Box {...containerProps}>
        {isLoading && <Spinner />}
        {!isLoading && <>
            <Typography {...typographyProps}>Ongoing Changes: {openChangesForAnimal.length}</Typography>
            {openChangesForAnimal.length > 0 && 
            <Typography {...typographyProps}>Last Change: {listLabel(openChangesForAnimal[0].category,(data?.categories || []))} {openChangesForAnimal[0].start.format(dateLocaleFormat())}</Typography>
        }
        </>}
    </Box>
    );
}